import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { EmojiPickerComponent } from "./emoji-picker.component";

@NgModule({
	imports: [CommonModule, FormsModule],
	declarations: [EmojiPickerComponent],
	exports: [EmojiPickerComponent]
})
export class EmojiPickerModule { }
